import * as svg from "../../../assets/square-plus-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const SquarePlusIcon = iconBuilder(svg, "SquarePlusIcon", "0 0 25 24");
